import { SvgIcon } from 'components/elements/svg-icon/SvgIcon';
import { useState } from 'react';
import {
  CopyCodeButton,
  TroubleshootingCodeContainer,
} from './troubleshooting-code.styles';
import { usePolyglotT } from 'utils/locale/locale';

// Display a troubleshooting code (clientId, correlationId, etc.) with copy functionality
export type TroubleshootingCodeProps = {
  code: string;
  label?: string; // Optional aria-label for accessibility
};

export const TroubleshootingCode = ({
  code,
  label,
}: TroubleshootingCodeProps) => {
  const [hasCopied, setHasCopied] = useState(false);
  const { t } = usePolyglotT();

  const copyCodeToClipboard = () => {
    if (code) {
      setHasCopied(true);

      const textToCopy = label ? `${label}: ${code}` : code;

      navigator.clipboard.writeText(textToCopy);
      setTimeout(() => {
        setHasCopied(false);
      }, 3000);
    }
  };

  return (
    <TroubleshootingCodeContainer>
      <span className='code' data-testid='troubleshooting-code'>
        {code}
      </span>
      {hasCopied && (
        <span className='copy-confirmed'>
          <SvgIcon
            data-testid='troubleshooting-checkmark-icon'
            src='/icons/checkmark.svg'
            height={14}
            width={14}
          />
          <span className='text'>{t('troubleshooting_details.copied')}</span>
        </span>
      )}
      {!hasCopied && navigator.clipboard && (
        <CopyCodeButton
          type='button'
          data-testid='troubleshooting-copy-button'
          isLoading={false}
          variant='transparent'
          onClick={copyCodeToClipboard}
          aria-label={t('troubleshooting_details.copy_error_id_aria_label')}
        >
          <SvgIcon
            data-testid='troubleshooting-copy-icon'
            src='/icons/copy.svg'
            height={14}
            width={14}
          />
          <span className='text active'>
            {t('troubleshooting_details.copy')}
          </span>
        </CopyCodeButton>
      )}
    </TroubleshootingCodeContainer>
  );
};
